export default {
  props: {
    /**
     * Par défaut, le model est un objet vide
     * @model
     */
    value: {
      type: Object,
      default: _.stubObject
    }
  },
  watch: {
    /**
     * Observe le modèle local et le vModel. Actualise le vModel si absent.
     */
    value: {
      immediate: true,
      handler (v) {
        if (!this.$options.propsData.value && v) {
          /**
           * @event input
           * @property {any} Le model
           */
          this.$emit('input', v)
        }
      }
    }
  }
}
